
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 36 36"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 13.17v4.28h2.62V30h5V17.39h3.51l.38-4.22h-3.86v-2.4c0-1 .2-1.39 1.16-1.39h2.73V5h-3.49c-3.74 0-5.43 1.65-5.43 4.81v3.36z","fill":"#fff","fill-rule":"evenodd"}})])
          )
        }
      }
    